import { FLOW_STATUS_LABEL, FLOW_STATUS_DOT } from './flow-inbox-utils';
import { timeAgo } from '@reflex/ui/lib/format';
import { cn } from '@reflex/ui/lib/utils';
import type { FlowRunSummary } from '@reflex/flows';

interface FlowRunSidebarRowProps {
  run: FlowRunSummary;
  selected: boolean;
  onClick: () => void;
}

export function FlowRunSidebarRow({ run, selected, onClick }: FlowRunSidebarRowProps) {
  const label = FLOW_STATUS_LABEL[run.status] ?? {
    text: run.status,
    className: 'text-muted-foreground',
  };
  const dotColor = FLOW_STATUS_DOT[run.status] ?? 'bg-status-neutral';

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex w-full items-start gap-2.5 rounded-md px-2.5 py-2 text-left transition-colors',
        selected
          ? 'bg-selected text-selected-foreground'
          : 'text-sidebar-foreground hover:bg-sidebar-accent/50',
        run.status === 'waiting_approval' &&
          !selected &&
          'bg-status-warning/5 hover:bg-status-warning/10',
      )}
    >
      <span className={cn('mt-1.5 h-2 w-2 shrink-0 rounded-full', dotColor)} />
      <div className="w-0 flex-1 overflow-hidden">
        <div className="flex items-baseline justify-between gap-2">
          <p className="truncate text-sm font-medium">{run.flowName}</p>
          <span className="shrink-0 text-[10px] text-muted-foreground tabular-nums">
            {timeAgo(run.createdAt, { compact: true })}
          </span>
        </div>
        <p className={cn('text-[11px] truncate', label.className)}>{label.text}</p>
        {run.currentNodeIds.length > 0 && (
          <p className="mt-0.5 text-[10px] text-muted-foreground truncate">
            {run.currentNodeIds.length} active {run.currentNodeIds.length === 1 ? 'node' : 'nodes'}
          </p>
        )}
      </div>
    </button>
  );
}
